module.exports = __webpack_public_path__ + "img/whatsapp.b2524e96.svg";